import React, { useContext, useEffect, useState } from 'react';
import format from 'date-fns/format';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';

import DataTable from 'components/DataTable';

import formatBtc from 'common/formatBtc';
import DataTablePagination from 'components/DataTablePagination';
import classNames from 'classnames';

const Funds = () => {
  const { addToast } = useContext(UiContext);
  const [page, setPage] = useState(1);

  const {
    data: payouts,
    isError: isError,
    isLoading: isLoading,
    isFetching,
  } = useApi('getList', '/api/payouts', { page });

  const headers = [
    'Date',
    'Wallet Address',
    'BTC Amount',
    'Status',
  ];

  const payoutList = () => payouts?.results.map(({
    date,
    wallet_address,
    amount,
    status,
  }: {
    date: string
    wallet_address: string
    amount: string
    status: string
  }) => [
    format(new Date(date), 'yyyy-MM-dd HH:mm:ss'),
    wallet_address,
    formatBtc(amount),
    {
      entry: status,
      formatter: 'StatusBadge',
    },
  ]);


  useEffect(() => {
    if(isError){
        addToast!('Error loading data. Please, retry');
    }
  }, [isError]);

  if(!payouts) {
    return null;
  }

  return (
    <>
      <div
        className={classNames({
          box: true,
          isLoading: isLoading || isFetching,
          table: true,
        })}
      >
        <DataTable isLoading={isLoading || isFetching} headers={headers} content={payoutList() ?? []} />
        <DataTablePagination
          page={page}
          totalItems={payouts?.count ?? 0}
          setPage={setPage}
        />
      </div>
    </>
  );
};

export default Funds;